import { useMemo } from "react";
import { BannerTcfVendor } from ".";
import { useBanner } from "../../../..";
import { Group } from "../../../common";
const BannerTcfVendorList = () => {
  const banner = useBanner();
  const {
    tcf: {
      gvl: {
        vendors: gvlVendors
      },
      model
    },
    tcfFilterBy,
    i18n: {
      tcf: {
        vendors,
        filterNoVendors
      }
    }
  } = banner;
  const useVendors = useMemo(() => Object.values(gvlVendors)
  // Only show vendor if suitable for the current filter
  .filter(_ref => {
    let {
      [tcfFilterBy === "consent" ? "purposes" : "legIntPurposes"]: usedPurposes
    } = _ref;
    return tcfFilterBy === "consent" ? true : usedPurposes.length > 0;
  })
  // We need to manually sort it again cause the `vendor-list.json#vendors` property uses numeric keys and
  // JavaScript does automatically sort it
  .sort((_ref2, _ref3) => {
    let {
      name: x
    } = _ref2;
    let {
      name: y
    } = _ref3;
    return x < y ? -1 : x > y ? 1 : 0;
  }), [gvlVendors, tcfFilterBy, model]);
  const hasVendors = useVendors.length > 0;
  return h(Group, {
    headline: vendors
  }, useVendors.map(_ref4 => {
    let {
      id
    } = _ref4;
    return h(BannerTcfVendor, {
      key: id,
      id: id
    });
  }), !hasVendors && filterNoVendors);
};
export { BannerTcfVendorList };